<div class="p-grid mt-2">
	<div class="p-col-12 p-md-6">
		<span class="p-float-label mt-4 mx-2 flex-fill">
			<input
				pInputText
				type="text"
				id="licenseName"
				name="licenseName"
				[(ngModel)]="onDevice.name"
				class="w-100"
				(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
			/>
			<label for="licenseName">Device Name</label>
		</span>
	</div>
	<div class="p-col">
		<div class="d-flex flex-column">
			<span class="p-float-label mt-4">
				<p-dropdown
					#sendToOnStationIdSelect
					[options]="venueService.stationList.value"
					optionLabel="Name"
					optionValue="ID"
					name="sendToOnStationIdSelect"
					[(ngModel)]="onDevice.stationId"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
					(filterBy)="app.keys(venueService.stationList.value)"
				></p-dropdown>
				<label for="sendToOnStationIdSelect">Send To ON Station</label>
			</span>
			<div class="descriptionText">
				Send To On allows a Focus POS station to <i>send</i> an order to a FocusON device for payment. Select the station you created in POS to house
				this ON device.
			</div>
			<span class="p-float-label mt-4">
				<p-dropdown
					#loyaltyTabStationIdSelect
					[options]="venueService.stationList.value"
					optionLabel="Name"
					optionValue="ID"
					name="loyaltyTabStationIdSelect"
					[(ngModel)]="onDevice.posStationId"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					(ngModelChange)="changesToSave = true; changesToSaveChange.emit(true)"
					(filterBy)="app.keys(venueService.stationList.value)"
				></p-dropdown>
				<label for="loyaltyTabStationIdSelect">LoyaltyTab Station ID</label>
			</span>
			<div class="descriptionText">
				LoyaltyTab is an experimental feature that allows a FocusON Tablet to receive order updates from POS and serve as a guest facing display.
			</div>
			<div class="descriptionText">Select the station in Focus POS that you want to receive orders from.</div>
		</div>
	</div>
</div>
